import { useTranslation } from 'react-i18next';

import { useData } from '@cold-ambulance/ui';

import { RequestCard, RequestCardSkeleton } from './request-card.tsx';

export default function RequestsPage() {
  const { t } = useTranslation();
  const requestsQuery = useData('GET /vendor/requests');

  return (
    <div className="page-container">
      <div className="mx-auto w-full max-w-3xl">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold">{t('requests.allRequests')}</h1>
        </div>

        {requestsQuery.isLoading ? (
          <div className="mt-8 grid grid-cols-1 gap-4">
            <RequestCardSkeleton />
            <RequestCardSkeleton />
            <RequestCardSkeleton />
          </div>
        ) : (
          <div className="mt-8 grid grid-cols-1 gap-4">
            {requestsQuery.data?.records.map((request) => (
              <RequestCard key={request.id} request={request} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
